<template>
  <div class="grid-css">
    <div v-if="showPlayer" class="grid__el--xs-12">
      <slot />
    </div>
    <div v-else class="grid__el--xs-12 grid__el--m-8 grid__el--l-6">
      <button-component :href="buttonHref" class="js-open-login-popup episode-player-wrapper__button">
        {{ buttonTitle }}
      </button-component>
      <p class="episode-player-wrapper__legal">
        {{ $t("legal") }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import globals from "utils/globals"
import ButtonComponent from "@/shared/button"

export default {
  name: "EpisodePlayerWrapper",
  components: {
    ButtonComponent
  },
  props: {
    episode: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "isUserLoggedOut", "hasUserAccessToContent", "isUserBasic"]),
    showPlayer() {
      return this.hasUserAccessToContent || this.episode.isFree
    },
    buttonTitle() {
      if (this.isUserLoggedOut) {
        return this.$t("login")
      } else if (this.isUserLoggedIn && this.isUserBasic) {
        return this.$t("getPremium")
      } else {
        return ""
      }
    },
    buttonHref() {
      if (this.isUserLoggedOut) {
        return globals.routes.login
      } else if (this.isUserLoggedIn && this.isUserBasic) {
        return globals.routes.plans
      } else {
        return ""
      }
    }
  },
  i18n: {
    messages: {
      en: {
        login: "Log in to enjoy this episode",
        getPremium: "Get Blinkist Premium",
        legal: "You can listen to this episode with a Premium subscription"
      },
      de: {
        login: "Einloggen und Episode anhören",
        getPremium: "Freischalten mit Premium",
        legal: "Verfügbar nur mit Blinkist Premium"
      }
    }
  }
}
</script>

<style lang="scss">
.episode-player-wrapper {
  &__button {
    width: 100%;
  }

  &__legal {
    @include font-style(caption);

    margin-top: $spacing-16;
    margin-bottom: 0;
  }
}
</style>
